import React from 'react';
import { Button, Form, ModalBody, ModalFooter } from 'reactstrap';
import { AlertTriangle } from "react-feather";

export const DeleteDoctor = ({ toggle, loading, name, saveDelete }) => {
    return (
        <Form role="form" onSubmit={saveDelete}>

            <div style={{
                display: "flex",
                alignItems: "center",
                gap: "15px",
                marginBottom: "15px"
            }}>
                <div style={{
                    backgroundColor: "#ffe6e6",
                    borderRadius: "50%",
                    width: "80px",
                    height: "48px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <AlertTriangle size={28} color="#c92a2a" />
                </div>

                <div>
                    {/* <h6 style={{ margin: 0, fontWeight: 600, color: "#0d3b59" }}>
                            ¿Eliminar este médico?
                        </h6> */}
                    <p
                        className="mb-0"
                        style={{
                            fontSize: "13px",
                            color: "#0d3b59"
                        }}
                    >
                        Esta acción no se puede deshacer. ¿Estás seguro de eliminar al médico?
                    </p>

                </div>
            </div>

            <div style={{
                background: "#f8fbff",
                padding: "12px 14px",
                borderRadius: "8px",
                border: "1px solid #d7e7f5"
            }}>
                <span style={{ fontWeight: 500, color: "#0d3b59" }}>
                    {name}
                </span>
            </div>
            <br />



        </Form>
    )
}
